import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { UIInstance } from '../../cvp-webgames-core/UI/UiManager';
import { setFocus } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import RecordsButtonWithText from '../helpers/RecordsButtonWithText';
import { UIProperties } from '../UIProperties';
import ContinueButton from './ContinueButton';

import './PatientRecordUI.css'

const PatientRecordUI = (props: UIProperties<PatientRecordUIConfig>) => {
	const [tabButtonBasicLeaveOn, setTabButtonBasicLeaveOn] = useState(false);
	const [tabButtonNursesLeaveOn, setTabButtonNursesLeaveOn] = useState(false);
	const [tabButtonLabLeaveOn, setTabButtonLabLeaveOn] = useState(false);
	const [tabButtonVitalsLeaveOn, setTabButtonVitalsLeaveOn] = useState(false);
	const [enabledTabIndx, setEnabledTabIndx] = useState(-1);
	const enableTabItem = (indx: number) => {

		setFocus('pr-tab-content')

		if(enabledTabIndx === indx) {
			return;
		}

		if(indx > 3) {
			indx = 0;
		}

		switch(indx) {
			case 0:
				setTabButtonBasicLeaveOn(true);
				setTabButtonNursesLeaveOn(false);
				setTabButtonLabLeaveOn(false);
				setTabButtonVitalsLeaveOn(false);
				break;
			case 1:
				setTabButtonBasicLeaveOn(false);
				setTabButtonNursesLeaveOn(true);
				setTabButtonLabLeaveOn(false);
				setTabButtonVitalsLeaveOn(false);
				break;
			case 2:
				setTabButtonBasicLeaveOn(false);
				setTabButtonNursesLeaveOn(false);
				setTabButtonLabLeaveOn(true);
				setTabButtonVitalsLeaveOn(false);
				break;
			case 3:
				setTabButtonBasicLeaveOn(false);
				setTabButtonNursesLeaveOn(false);
				setTabButtonLabLeaveOn(false);
				setTabButtonVitalsLeaveOn(true);
				break;
		}

		setEnabledTabIndx(indx);
	};

	if(enabledTabIndx === -1) {
		if(props.parameters.basic) {
			enableTabItem(0);
		} else if(props.parameters.nurses) {
			enableTabItem(1);
		} else if(props.parameters.lab) {
			enableTabItem(2);
		} else if(props.parameters.vitals) {
			enableTabItem(3);
		}
	}

	const renderEOC = (tabIndx: number) => {
		return (
			<p tabIndex={0} aria-label='end of content' onKeyDown={(e) => {
				if ((e.key === 'Tab' || e.which === 9) && !e.shiftKey) {
					setFocus('pr-tab-' + tabIndx);
					e.preventDefault();
				}
			}}></p>
		);
	}

	return (
		<div id={props.id} className="in-game-ui-container ui-top-most-container modal-bg pr-fade-in modal-disable-select">
			<div tabIndex={0} id='first-object-pr' aria-label='Patient Record' className="pr-container">
				<img src="./assets/images/general/components/patient-record/pr-background.png"/>
				<div className="pr-header-item pr-border">
					<div className="pr-text-left1">
						<p tabIndex={0} className="pr-basic-item-description big-description-font" dangerouslySetInnerHTML={{ __html: props.parameters.top[0].description }}></p>
					</div>
					<div className="pr-text-left2">
						<p tabIndex={0} className="pr-basic-item-description big-description-font" dangerouslySetInnerHTML={{ __html: props.parameters.top[1].description }}></p>
					</div>
				</div>
				<div className="pr-header-item pr-border">
					<div className="pr-text-right1">
						<p tabIndex={0} className="pr-basic-item-description big-description-font" dangerouslySetInnerHTML={{ __html: props.parameters.top[2].description }}></p>
					</div>
					<div className="pr-text-right2">
						<p tabIndex={0} className="pr-basic-item-description big-description-font" dangerouslySetInnerHTML={{ __html: props.parameters.top[3].description }}></p>
					</div>
				</div>
				{props.parameters.basic && props.parameters.nurses && props.parameters.lab && props.parameters.vitals ? <div className="pr-tabs-container">
					<RecordsButtonWithText parameters= {{
							ariaLabel:'Basic Information',
							id: 'pr-tab-0',
							srcIdle: './assets/images/general/components/patient-record/button_patientrecord_tab_main.png',
							srcHighlight: './assets/images/general/components/patient-record/button_patientrecord_tab_down.png',
							top: '200px',
							left: '25px',
							width: '413.33px',
							text: 'Basic Information',
							highlightOnHover: true,
							shouldLeaveOn: tabButtonBasicLeaveOn,
							onClicked: () => {
								enableTabItem(0);
							}
					}}/>
					<RecordsButtonWithText parameters= {{
							ariaLabel:'Nurses Notes',
							id: 'pr-tab-1',
							srcIdle: './assets/images/general/components/patient-record/button_patientrecord_tab_main.png',
							srcHighlight: './assets/images/general/components/patient-record/button_patientrecord_tab_down.png',
							top: '300px',
							left: '25px',
							width: '413.33px',
							text: 'Nurses Notes',
							highlightOnHover: true,
							shouldLeaveOn: tabButtonNursesLeaveOn,
							onClicked: () => {
								enableTabItem(1);
							}
					}}/>
					<RecordsButtonWithText parameters= {{
							ariaLabel:'Lab Results',
							id: 'pr-tab-2',
							srcIdle: './assets/images/general/components/patient-record/button_patientrecord_tab_main.png',
							srcHighlight: './assets/images/general/components/patient-record/button_patientrecord_tab_down.png',
							top: '400px',
							left: '25px',
							width: '413.33px',
							text: 'Lab Results',
							highlightOnHover: true,
							shouldLeaveOn: tabButtonLabLeaveOn,
							onClicked: () => {
								enableTabItem(2);
							}
					}}/>
					<RecordsButtonWithText parameters= {{
							ariaLabel:'Vitals',
							id: 'pr-tab-3',
							srcIdle: './assets/images/general/components/patient-record/button_patientrecord_tab_main.png',
							srcHighlight: './assets/images/general/components/patient-record/button_patientrecord_tab_down.png',
							top: '500px',
							left: '25px',
							width: '413.33px',
							text: 'Vitals',
							highlightOnHover: true,
							isLastButton: true,
							shouldLeaveOn: tabButtonVitalsLeaveOn,
							onClicked: () => {
								enableTabItem(3);
							}
					}}/>
				</div> : (null)}

				<div className="pr-main-content-container">
					{tabButtonBasicLeaveOn ? 
					(<div className="pr-basic-container pr-main-content-item">
						<div id='pr-tab-content' className="pr-basic-item disable-select pr-border" tabIndex={0} aria-label='content'>
							{props.parameters.basic.map((item: PatientRecordUIBasicConfig, index: number) => {
								return (
									<div>
										<p tabIndex={0} className="pr-basic-item-title big-description-font">{item.title}</p>
										<p tabIndex={0} className="pr-basic-item-list regular-description-font" dangerouslySetInnerHTML={{ __html: item.description }}></p>
									</div>
								);
							})}
							{renderEOC(0)}
						</div>
					</div>) : (null)}

					{tabButtonNursesLeaveOn ? 
					(<div className="pr-basic-container pr-main-content-item">
						<div id='pr-tab-content' className="pr-basic-item disable-select pr-border" tabIndex={0} aria-label='content'>
							{props.parameters.nurses.map((item: PatientRecordUINursesConfig, index: number) => {
								return (
									<div>
										<p tabIndex={item.visit ? 0 : -1} className="pr-basic-item-visit big-description-font">{item.visit}</p>
										{item.lineBreak ? (<hr style={{ 
											backgroundColor: 'rgb(214, 136, 19)',
											height: '2px'
										}} />):(null)}
										<p tabIndex={item.title ? 0 : -1} className="pr-basic-item-title big-description-font">{item.title}</p>
										<p tabIndex={item.header ? 0 : -1} className="pr-basic-item-header" dangerouslySetInnerHTML={{ __html: item.header }}></p>
										<ul className="pr-basic-item-list" style={{
											listStyleType: 'disc',
										}} tabIndex={item.list ? 0 : -1} dangerouslySetInnerHTML={{ __html: item.list }}></ul>
									</div>
								);
							})}
							{renderEOC(1)}
						</div>
					</div>) : (null)}

					{tabButtonLabLeaveOn ? 
					(<div className="pr-basic-container pr-main-content-item">
					<div id='pr-tab-content' className="pr-table disable-select pr-border" tabIndex={0} aria-label='content'>
						<table className="pr-basic-table">
							<tr className="pr-table-title big-description-font">
								<th className="pr-table-border">{props.parameters.lab[0].title}</th>
								<th className="pr-table-border">{props.parameters.lab[1].title}</th>
								<th className="pr-table-border">{props.parameters.lab[2].title}</th>
							</tr>
							{props.parameters.lab.map((item: PatientRecordUILabConfig, index: number) => {
								return (
										<tr className="pr-table-description regular-description-font">
											<td tabIndex={item.description1 ? 0 : -1} className="pr-table-border">{item.description1}</td>
											<td tabIndex={item.description2 ? 0 : -1} className="pr-table-border" dangerouslySetInnerHTML={{ __html: item.description2 }}></td>
											<td tabIndex={item.description3 ? 0 : -1} className="pr-table-border" dangerouslySetInnerHTML={{ __html: item.description3 }}></td>
										</tr>
								);
							})}
						</table>
						{renderEOC(2)}
					</div>
				</div>) : (null)}

					{tabButtonVitalsLeaveOn ? 
					(<div className="pr-basic-container pr-main-content-item">
						<div id='pr-tab-content' className="pr-basic-item disable-select pr-border" tabIndex={0} aria-label='content'>
							{props.parameters.vitals.map((item: PatientRecordUIVitalsConfig, index: number) => {
								return (
									<div>
										<p tabIndex={item.title ? 0 : -1} className="pr-basic-item-title big-description-font">{item.title}</p>
										<p tabIndex={item.description ? 0 : -1} className="pr-basic-item-list regular-description-font" dangerouslySetInnerHTML={{ __html: item.description }}></p>
										<ul tabIndex={item.list ? 0 : -1} className="pr-basic-item-list regular-description-font" style={{
											listStyleType: 'disc',
										}} dangerouslySetInnerHTML={{ __html: item.list }}></ul>
									</div>
								);
							})}
							{renderEOC(3)}
						</div>
					</div>) : (null)}

					<ContinueButton parameters= {{
						id: 'last-object-pr',
						ariaLbl: 'close',
						isPR: true,
						top: '77%',
						left: '60px',
						width: '190px',
						highlightOnHover: true,
						isClose: true,
						onClicked: () => {
							var el = document.getElementById(props.id);
							el.classList.remove('pr-fade-in');
							el.classList.add('pr-fade-out');

							setTimeout(() => {
								props.parameters.onClosed(props.parameters);
							}, 1000);
						}
					}}/>
				</div>
			</div>
			
		</div>
	);

};

export interface PatientRecordUIConfig extends BaseConfig {
	top: PatientRecordUITopConfig[];
	basic: PatientRecordUIBasicConfig[];
	nurses: PatientRecordUINursesConfig[];
	lab: PatientRecordUILabConfig[];
	vitals: PatientRecordUIVitalsConfig[];
	onClosed: (config: PatientRecordUIConfig) => void;
}

export interface PatientRecordUITopConfig {
	description: string;
}

export interface PatientRecordUIBasicConfig {
	title: string;
	description?: string;
}

export interface PatientRecordUINursesConfig {
	visit: string;
	title: string;
	header: string;
	list: string;
	lineBreak?: boolean;
}

export interface PatientRecordUILabConfig {
	title: string;
	description1: string;
	description2: string;
	description3: string;
}

export interface PatientRecordUIVitalsConfig {
	title: string;
	description?: string;
	list: string;
}

export default PatientRecordUI;